module.exports = __webpack_public_path__ + "img/slash-square.58040e63.svg";